// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:36:43

export default {
  "id": "tile-connect-pair-match-puzzle",
  "slug": "tile-connect-pair-match-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/245f2f115b1e4f9ba8cf43bb1aca488a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/245f2f115b1e4f9ba8cf43bb1aca488a/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Tile Connect Pair Match Puzzle",
      "description": "Match & connect tiles of same color & be the master of pair matching puzzle game. In this you have to find and match the same objects. There are different objects.",
      "instructions": "Match The things to complete the game. Click on same objects to match them.",
      "genres": [
        ".IO",
        "Puzzle"
      ],
      "tags": [
        "candy",
        "crush",
        "match3",
        "matching",
        "maze"
      ]
    },
    "zh-CN": {
      "title": "拼图连连对匹配谜题",
      "description": "匹配并连接相同颜色的瓷砖，成为配对匹配谜题游戏的大师。在这里，你需要找到并匹配相同的物体。这里有不同的物体。",
      "instructions": "匹配物品以完成游戏。点击相同的对象进行匹配。",
      "genres": [
        ".IO",
        "拼图"
      ],
      "tags": [
        "糖果",
        "消消乐",
        "三消",
        "匹配",
        "迷宫"
      ]
    },
    "zh-TW": {
      "title": "瓦片連接配對拼圖",
      "description": "匹配並連接同色塊，成為配對拼圖遊戲的大師。在這個遊戲中，您必須尋找並匹配相同的物件。有不同種類的物件。",
      "instructions": "將事物配對以完成遊戲。點擊相同的物件來配對它們。",
      "genres": [
        ".IO",
        "謎題"
      ],
      "tags": [
        "糖果",
        "crush",
        "三消",
        "匹配",
        "迷宮"
      ]
    },
    "zh-HK": {
      "title": "磁磚連接配對解謎遊戲",
      "description": "匹配並連接同色磁磚，成為配對謎題遊戲的大師。在這裡，你必須尋找並匹配相同的物品。有各種不同的物品。",
      "instructions": "匹配物品以完成遊戲。點擊相同的物品以匹配。",
      "genres": [
        ".IO",
        "謎題"
      ],
      "tags": [
        "糖果",
        "crush",
        "三消",
        "配對",
        "迷宮"
      ]
    },
    "ja": {
      "title": "タイルコネクト・ペアマッチパズル",
      "description": "同じ色のタイルをマッチ＆接続し、ペアマッチパズルゲームのマスターになろう。ここでは同じオブジェクトを見つけ、マッチングする必要があります。さまざまなオブジェクトがあります。",
      "instructions": "ゲームを完了するために物を一致させます。同じオブジェクトをクリックして一致させます。",
      "genres": [
        ".IO",
        "パズル"
      ],
      "tags": [
        "キャンディクラッシュ",
        "マッチ3",
        "マッチング",
        "迷路"
      ]
    },
    "ko": {
      "title": "타일 커넥트 페어 매치 패uzzle",
      "description": "색상이 같은 타일을 매칭하고 파이어링 매치 퍼즐 게임의 마스터가 되세요. 이 게임에서는 같은 물체를 찾아 매칭해야 합니다. 다양한 물체가 있습니다.",
      "instructions": "게임을 완료하려면 물건을 일치시켜주세요. 같은 물건을 클릭하여 일치시켜주세요.",
      "genres": [
        ".이오",
        "퍼즐"
      ],
      "tags": [
        "캔디 크러시",
        "매치3",
        "매칭",
        "루브릭"
      ]
    },
    "fr": {
      "title": "Puzzle de correspondance Pair Match Tile Connect",
      "description": "Convertissez les tuiles de la même couleur et devenez le maître du jeu de puzzle de correspondance par paires. Dans ce jeu, vous devez trouver et correspondre aux mêmes objets. Il y a différents objets.",
      "instructions": "Association des éléments pour terminer le jeu. Cliquez sur des objets identiques pour les association.",
      "genres": [
        ".IO",
        "Puzzle\n- IO : IO\n- Puzzle : Puzzle"
      ],
      "tags": [
        "candy",
        "crush",
        "match3",
        "correspondance",
        "labyrinthe"
      ]
    }
  }
};
